import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-table-action-button',
  templateUrl: './table-action-button.component.html',
  styleUrls: ['./table-action-button.component.sass']
})
export class TableActionButtonComponent implements ICellRendererAngularComp, OnDestroy {
  public params

  _show: boolean = true

  unsub$ = new Subject()

  get currRowNode() {
    return this.params?.node
  }

  agInit(params: any): void {
    this.params = params;
    const { data, hovering$, leaving$ } = params
    if (!data) this._show = false

    if (hovering$ && leaving$) {
      this._show = false;

      (hovering$ as BehaviorSubject<string>).pipe(takeUntil(this.unsub$.asObservable())).subscribe(nodeId => {
        if (!nodeId || nodeId !== this.currRowNode?.id) return
        this._show = true
      });

      (leaving$ as BehaviorSubject<string>).pipe(takeUntil(this.unsub$.asObservable())).subscribe(nodeId => {
        if (!nodeId || nodeId !== this.currRowNode?.id) return
        this._show = false
      })
    }
  }

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  detail() {
    this.params.detail(this.params.data)
  }

  edit() {
    this.params.edit(this.params.data)
  }

  delete() {
    this.params.delete(this.params.data)
  }

  ngOnDestroy() {
    // no need to remove the button click handler 
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
    this.unsub$.next()
    this.unsub$.unsubscribe()
  }
}
